export default __webpack_public_path__ + "static/media/miguel-lopes-3.5ca1cd88.jpg";